// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__aeonik_ca39ce', '__aeonik_Fallback_ca39ce', system-ui"},"className":"__className_ca39ce","variable":"__variable_ca39ce"};